import { render, staticRenderFns } from "./more.vue?vue&type=template&id=a0baeb1a&lang=pug&"
import script from "./more.vue?vue&type=script&lang=ts&"
export * from "./more.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports